// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drop-zone {
  border: 2px dashed #007BFF;
  border-radius: 10px;
  width: 400px;
  height: 200px;
  background-color: #ffffff;
  color: #666;
  text-align: center;
  padding: 30px;
  margin: auto;
  cursor: pointer;
  transition: background-color 0.3s, border-color 0.3s;
}
.drop-zone p {
  font-size: 16px;
  margin-top: 40px;
}

.drop-zone.hover {
  background-color: #e8f0fe;
  border-color: #0056b3;
  color: #0056b3;
}

.file-info {
  height: 20px;
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
}
.file-info div {
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/view/routes/upload-excel/upload-excel.component.scss"],"names":[],"mappings":"AAAA;EACI,0BAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,oDAAA;AACJ;AACI;EACI,eAAA;EACA,gBAAA;AACR;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,cAAA;AAAJ;;AAGA;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;AACI;EACI,aAAA;EACA,8BAAA;AACR","sourcesContent":[".drop-zone {\n    border: 2px dashed #007BFF;\n    border-radius: 10px;\n    width: 400px;\n    height: 200px;\n    background-color: #ffffff;\n    color: #666;\n    text-align: center;\n    padding: 30px;\n    margin: auto;\n    cursor: pointer;\n    transition: background-color 0.3s, border-color 0.3s;\n\n    p {\n        font-size: 16px;\n        margin-top: 40px;\n    }\n}\n\n.drop-zone.hover {\n    background-color: #e8f0fe;\n    border-color: #0056b3;\n    color: #0056b3;\n}\n\n.file-info {\n    height: 20px;\n    margin-top: 20px;\n    font-size: 14px;\n    font-weight: bold;\n    div {\n        display: flex;\n        justify-content: space-between;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
